<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">增值服务配置</span>
    </div>
    <el-form ref="queryForm" :model="queryForm" label-width="260px">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="启用服务" prop="webTitle">
            <el-checkbox-group v-model="checkList">
              <el-checkbox label="橘子手机验证"></el-checkbox>
              <el-checkbox label="橘子身份证验证"></el-checkbox>
              <el-checkbox label="橘子旺旺验证"></el-checkbox>
              <el-checkbox label="待操作订单语音提醒"></el-checkbox>
              <el-checkbox label="订单催评语音提醒"></el-checkbox>
              <el-checkbox label="旺旺本品打标"></el-checkbox>
              <el-checkbox label="旺旺降权查询"></el-checkbox>
              <el-checkbox label="商品信息查询"></el-checkbox>
              <el-checkbox label="淘口令解析"></el-checkbox>
              <el-checkbox label="二维码加购"></el-checkbox>
              <el-checkbox label="流量任务"></el-checkbox>
              <el-checkbox label="淘客订单查询"></el-checkbox>
              <el-checkbox label="物流"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="增值服务AppKey" prop="webTitle">
            <el-input v-model="queryForm.webTitle" placeholder="AppKey"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="增值服务AppSecret" prop="webTitle">
            <el-input v-model="queryForm.webTitle" placeholder="AppSecret"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="商家语音通知价格(元/次)" prop="webTitle">
            <el-input v-model="queryForm.webTitle" placeholder="请输入价格"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="审核旺旺自动查询降权" prop="webTitle">
            <el-radio-group v-model="queryForm.isneedReview" @change="tackReviewChange">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="商家旺旺自动查询价格(元/次)" prop="webTitle">
            <el-input v-model="queryForm.webTitle" placeholder="请输入价格"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="商家淘客订单查询价格(元/次)" prop="webTitle">
            <el-input v-model="queryForm.webTitle" placeholder="请输入价格"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="商家旺旺打标价格(元/次)" prop="webTitle">
            <el-input v-model="queryForm.webTitle" placeholder="请输入价格"></el-input>
            <span>(商家端电商工具中有效)</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="二维码架加购价格(元/次)" prop="webTitle">
            <el-input v-model="queryForm.webTitle" placeholder="请输入价格"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="流量任务服务费(元/次)" prop="webTitle">
            <el-input v-model="queryForm.webTitle" placeholder="请输入价格"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">商家任务</span>
    </div>
    <el-form ref="queryForm" :model="queryForm" label-width="260px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="商家任务查降权最大次数" prop="webTitle">
            <el-input v-model="queryForm.webTitle" placeholder="请输入次数"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="降权号是否重新审核" prop="webTitle">
              <el-radio-group v-model="queryForm.isneedReview" @change="tackReviewChange">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-form>
      <el-row :gutter="30" style="text-align: center">
        <el-col span="10" style="text-align: right">
          <el-button type="info" icon="el-icon-back">返回</el-button>
        </el-col>
        <el-col span="10" style="text-align: left">
          <el-button type="primary" icon="el-icon-folder">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</div>
</template>

<script>
import MixinCUD from "@/components/MixinCUD";
export default {
  name: "AdditionalService",
  mixins:[MixinCUD],
  data(){
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      tableData:[],
      queryForm:{
        isneedReview:0,
      },
      checkList: [],
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
      checkList1: []
    }
  },
  methods: {
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    tackReviewChange(val){
    }
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
.demo-input-suffix {
  margin-bottom: 15px;
}
</style>
